import httpService from '../httpService';
import { InvoiceData, PaymentDetails } from '../../types/payments';
import { BusinessSubscriptionType, SubscriptionType } from '../../types/misc';
import { MemberCommunityDto } from '../../types/community';
import { store } from '../../redux/store';
import { RootState } from '../../redux/reducers';

export const businessSubscriptionService = {
  prepareSubscription: async (subscriptionType: BusinessSubscriptionType): Promise<{
    status: 'subscription_already_active' | 'subscription_prepared';
    clientSecret?: string;
    customerId?: string;
  }> => {
    const { selectedBusiness } = (store.getState() as RootState).application;
    const res = await httpService.post(`/networks/businesses/${selectedBusiness}/subscription/prepare`, { subscriptionType });
    return res.data;
  },

  getSubscriptionUsage: async (): Promise<{ memberCount: number; subCommunities: MemberCommunityDto[] }> => {
    const { selectedBusiness } = (store.getState() as RootState).application;
    const res = await httpService.get(`/networks/businesses/${selectedBusiness}/subscription/usage`);
    return res.data;
  },

  changeSubscription: async (subscriptionType: BusinessSubscriptionType): Promise<void> => {
    const { selectedBusiness } = (store.getState() as RootState).application;
    await httpService.put(`/networks/businesses/${selectedBusiness}/subscription/`, { subscriptionType });
  },

  cancelSubscription: async (): Promise<void> => {
    const { selectedBusiness } = (store.getState() as RootState).application;
    await httpService.delete(`/networks/businesses/${selectedBusiness}/subscription/`);
  },

  getPaymentDetails: async (): Promise<PaymentDetails> => {
    const { selectedBusiness } = (store.getState() as RootState).application;
    const res = await httpService.get(`/networks/businesses/${selectedBusiness}/subscription/payment-details`);
    return res.data;
  },

  getLastInvoices: async (limit: number): Promise<InvoiceData[]> => {
    const { selectedBusiness } = (store.getState() as RootState).application;
    const res = await httpService.get(`/networks/businesses/${selectedBusiness}/subscription/invoices?limit=${limit}`);
    return res.data;
  },

  fetchInvoicePdf: async (invoiceId: string): Promise<Blob> => {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
      .get(`/networks/businesses/${selectedBusiness}/subscription/invoices/pdfs/${invoiceId}`, { responseType: 'blob' })
      .then((res) => res.data);
  },

  getEndDate: async (): Promise<number | null> => {
    const { selectedBusiness } = (store.getState() as RootState).application;
    const res = await httpService.get(`/networks/businesses/${selectedBusiness}/subscription/end-date`);
    return res.data;
  },

  reactivateSubscription: async () => {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService.put(`/networks/businesses/${selectedBusiness}/subscription/reactivate`);
  },

  changeSubCommunitySubscription: async (
    businessId: number,
    communityId: number,
    subscriptionType: SubscriptionType,
  ): Promise<void> => {
    await httpService.put(
      `/networks/businesses/${businessId}/communities/${communityId}/subscription`,
      { subscriptionType },
    );
  },
};
